import { api } from '../api';

export const timeAuditReport = api.injectEndpoints({
    endpoints: (builder) => ({
        getTimeAuditReports: builder.query({
            query: (payload) => ({
                url: 'api/report/therapy-session-time-comparison-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        })
    })
});

export const { useLazyGetTimeAuditReportsQuery } = timeAuditReport;
